import create from "zustand";

interface AdminPrefsState {
  commentEditMode: boolean;
  missionEditMode: boolean;
  toggleCommentEditMode: () => void;
  toggleMissionEditMode: () => void;
}

export const useAdminPrefs = create<AdminPrefsState>((set) => ({
  commentEditMode: false,
  missionEditMode: false,
  toggleCommentEditMode: () => set((s) => ({ commentEditMode: !s.commentEditMode })),
  toggleMissionEditMode: () => set((s) => ({ missionEditMode: !s.missionEditMode })),
}));
